/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateVideoDto } from '../../models/create-video-dto';
import { VideoDto } from '../../models/video-dto';

export interface VideoControllerCreate$Params {
      body: CreateVideoDto
}

export function videoControllerCreate(http: HttpClient, rootUrl: string, params: VideoControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<VideoDto>> {
  const rb = new RequestBuilder(rootUrl, videoControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VideoDto>;
    })
  );
}

videoControllerCreate.PATH = '/api/videos';
